import { Record as record, List } from 'immutable';

import translate from '../lib/I18n';
import { resolve } from '../helpers/LinkMapper';
import CarnetInformation from './CarnetInformation';
import FlexiInformation from './FlexiInformation';
export const daySaveTypes = new List(['SD4', 'SD1', 'SDP', 'SS0']);
export const daySaveOffPeakTypes = new List(['SD1', 'SD4']);
export const plusBusTypes = new List(['PBD', 'PB7', 'BMS', 'BQS', 'BAS', 'PBW']);
const returnTravelcardTypes = new List(['ODT', 'ADT', 'FDT', 'AM3', 'SOE', 'SOT', 'STO', 'STP', 'WRE', 'WTC', '0CA', '0CC', '0CE', 'FTC']);
const roversRangersTypes = List.of('14R', 'R07', 'H37', 'HE7', 'WM1', 'WM3', 'MTR', 'E37', 'EM7', 'NC8', 'NE8', 'NE7', 'NES', 'N37', 'NW7', 'WER', 'GM1');
const allLineRovers = List.of('14R', 'R07');
const familyDayRangerType = 'WM3';
const nonFamilyDayRangerType = 'WM1';

const defaults = {
    id: null,
    name: null,
    code: null,
    description: null,
    isReturn: null,
    isSeason: null,
    isFlexi: null,
    isAdvance: null,
    isPackage: null,
    isCarnet: null,
    isFirstClass: null,
    validityCode: null,
    carnetInformation: null,
    flexiInformation: null
};

class TicketType extends record(defaults) {

    static fromJSON (json) {
        json = json || {};

        const name = resolve(json.name).with(String);
        const translatedName = name ? translate(name) : name;
        const code = resolve(json.code).with(String);
        const description = resolve(json.description).with(String);
        const isReturn = resolve(json.isReturn).with(Boolean);
        const isSeason = resolve(json.isSeason).with(Boolean);
        const isFlexi = resolve(json.isFlexi).with(Boolean);
        const isAdvance = resolve(json.isAdvance).with(Boolean);
        const isPackage = resolve(json.isPackage).with(Boolean);
        const isCarnet = resolve(json.isCarnet).with(Boolean);
        const isFirstClass = resolve(json.isFirstClass).with(Boolean);
        const validityCode = resolve(json.validityCode).with(String);
        const carnetInformation = resolve(json.carnetInformation).as(CarnetInformation);
        const flexiInformation = resolve(json.flexiInformation).as(FlexiInformation);

        return new TicketType({
            name: translatedName,
            code,
            description,
            isReturn,
            isFlexi,
            isSeason,
            isPackage,
            isAdvance,
            isCarnet,
            isFirstClass,
            validityCode,
            carnetInformation,
            flexiInformation,
        });
    }

    static getFamilyRangerCode() {
        return familyDayRangerType;
    }

    isDaySave () {
        return daySaveTypes.includes(this.code);
    }

    isRoversRangers () {
        return roversRangersTypes.includes(this.code);
    }

    isFamilyRanger() {
        return familyDayRangerType === this.code;
    }

    isNonFamilyRanger() {
        return nonFamilyDayRangerType === this.code;
    }

    isDaySaveOffPeak () {
        return daySaveOffPeakTypes.includes(this.code);
    }

    isPlusBus () {
        return plusBusTypes.includes(this.code);
    }

    isReturnTravelcard () {
        return returnTravelcardTypes.includes(this.code);
    }

    isAllLineRovers () {
        return allLineRovers.includes(this.code);
    }

    // HACK to prevent '1 Child Child Flat Fare Single' from being displayed:
    shortenName () {
        return this.name.split(' ').slice(1).join(' ');
    }

    ticketMultiplier () {
        if (this.isCarnet) {
            return this.getIn(['carnetInformation', 'numberOfTickets'], 1);
        } else if (this.isFlexi) {
            return this.getIn(['flexiInformation', 'numberOfTickets'], 1);
        }
        return 1;
    }

    isAnytime () {
        return this.name && this.name.toLowerCase().includes('anytime');
    }
}


export default TicketType;
